var map = {
	"./down.svg": "c166",
	"./fail.svg": "dec8",
	"./left.svg": "45e3",
	"./logo-zh.svg": "0af0",
	"./logo.svg": "7485",
	"./mobile-home.svg": "f064",
	"./mobile-redemption.svg": "442d",
	"./mobile-user.svg": "d658",
	"./mobile.svg": "fb05",
	"./plus.svg": "3537",
	"./right.svg": "8108",
	"./scan.svg": "d171",
	"./success.svg": "eb57",
	"./user-avatar.svg": "b654",
	"./user.svg": "9090"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cef9";